export default {
    customersAll: [],
    customersFiltered: [],
    // Novos estados para otimização
    isLoading: false,
    searchTerm: '',
    searchCache: new Map(),
    lastFetch: null,
    cacheExpiry: 5 * 60 * 1000, // 5 minutos
    currentPage: 1,
    itemsPerPage: 50,
    totalItems: 0
  }